<template>
  <div class="vin-checker">
    <form class="vin-checker__form" @submit.prevent="submitForm">
      <BaseInput
        :label="title"
        :value="code"
        class="vin-checker__input"
        :placeholder="placeholderText"
        mask="vin"
        :disabled="isLoading"
        @input="code = $event.toUpperCase()"
      >
        <template #hint>
          <BaseHint :options="{ ...tooltipOptions }"/>
        </template>
      </BaseInput>

      <BaseButton
        ref="button"
        :disabled="code.length !== 17"
        :isLoading="isLoading"
        class="vin-checker__button"
        tagType="submit"
      >
        {{ buttonText }}
      </BaseButton>
    </form>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { get } from 'lodash'
  import { DEFAULT_LANG } from '@/helpers/constant'

  export default {
    name: 'VinChecker',

    data () {
      return {
        hintRight: null,
        isLoading: false,
        errText: '',
        code: '',
        tooltipOptions: {
          offset: 13,
          classes: ['info'],
          targetClasses: ['it-has-a-tooltip'],
          delay: {
            show: 100,
            hide: 100
          }
        }
      }
    },

    computed: {
      ...mapState(['general']),
      title () {
        return get(this, 'general.vin-checker.title')
      },
      buttonText () {
        return get(this, 'general.vin-checker.buttonText')
      },
      placeholderText () {
        return get(this, 'general.vin-checker.placeholder')
      }
    },

    activated () {
      this.reset()
    },

    methods: {
      ...mapActions(['submitVinCode']),
      async submitForm () {
        try {
          this.$store.commit('SET_VIN_SEARCH_DATA', {})
          this.isLoading = true
          this.errText = ''
          const res = await this.submitVinCode({
            form: { vin: this.code }
          })
          // data for next pages
          this.$store.commit('SET_VIN_SEARCH_DATA', {
            vin: this.code,
            open_campaigns: res.modelOpenCampaignsSpec,
            modelOpenCampaignsMessage: res.modelOpenCampaignsMessage
          })
          if (res.modelParams && res.modelParams.carModelId) {
            let langQuery = {}

            if (this.$store.state.currentLang !== DEFAULT_LANG) {
              langQuery = { lang: this.$store.state.currentLang }
            }

            this.$router.push({
              name: 'tech-map',
              params: {
                model: res.modelParams.carModelId,
                year: res.modelParams.generationId,
                modification: res.modelParams.modificationId
              },
              query: {
                langQuery
              }
            })
          } else {
            this.errText = res.modelNotFoundMessage
            this.$emit('errText', { text: this.errText, color: 'gray' })
          }
        } catch (err) {
          if (err.response.data) {
            this.errText = err.response.data.vin
            this.$emit('errText', { text: this.errText, color: 'red' })
          }
        } finally {
          this.isLoading = false
        }
      },
      reset () {
        this.code = ''
        this.errText = ''
        this.$store.commit('SET_VIN_SEARCH_DATA', {})
      }
    }
  }
</script>

<style lang="scss">
.vin-checker {
  width: 450px;

  @include tablet {
    width: 100%;
  }

  &__form {
    position: relative;
    display: flex;
    align-items: flex-end;
    justify-content: center;

    @include mobile {
      flex-direction: column;
      align-items: center;
    }

    .base-hint {
      position: absolute;
      top: -36px;
      right: 0;
      z-index: 2;
      height: 28px;

      @include mobile {
        top: -32px;
        height: 20px;

        svg {
          width: 20px;
          height: 20px;
        }
      }
    }

    .vin-checker__input {
      padding-bottom: 0;
      margin-right: 10px;

      @include tablet {
        min-width: 500px;
      }

      @include mobile {
        min-width: 100%;
        margin-right: 0;
      }
    }
  }

  &__input {
    width: 260px;
    min-width: 260px !important;

    @include tablet {
      width: 100%;
      max-width: 100% !important;
    }

    @include mobile {
      margin-bottom: 20px;
    }
  }

  &__button {
    width: 180px;

    @include tablet {
      min-width: 170px !important;
      max-width: 170px;
    }

    @include mobile {
      min-width: 100% !important;
      max-width: 100%;
    }
  }
}
</style>
